import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RegisterSchema} from "../types/registerSchema";
import {registerByUser} from "../service/register-by-user/registerByUser";
import {loginSlice} from "./lodinSlice";




interface RegisterState extends RegisterSchema {
    status: 'idle' | 'pending' | 'fulfilled' | 'rejected';
    errors: Record<string, string>;
    isLoading: boolean;
    success: boolean;
    emailConfirmation:boolean;
    message:{
        text:string,
        title:string
    }
}


const initialRegisterState: RegisterState = {
    status: 'idle',
    isLoading: false,
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    retypePassword: "",
    privacyAccept: false,
    promoCode: "",
    errors: {},
    success: false,
    emailConfirmation:false,
    message:{
        text:'',
        title:'',
    }
};

export const registerSlice = createSlice({
    name: "register",
    initialState: initialRegisterState,
    reducers: {
        setFirstName: (state, action: PayloadAction<string>) => {
            state.firstName = action.payload;
        },
        setLastName: (state, action: PayloadAction<string>) => {
            state.lastName = action.payload;
        },
        setEmail: (state, action: PayloadAction<string>) => {
            state.email = action.payload;
        },
        setPhone: (state, action: PayloadAction<string>) => {
            state.phone = action.payload;
        },
        setPassword: (state, action: PayloadAction<string>) => {
            state.password = action.payload;
        },
        setRetypePassword: (state, action: PayloadAction<string>) => {
            state.retypePassword = action.payload;
        },
        setPrivacyAccept: (state, action: PayloadAction<boolean>) => {
            state.privacyAccept = action.payload;
        },
        setPromoCode: (state, action: PayloadAction<string>) => {
            state.promoCode = action.payload;
        },
        setRegisterData: (state, action: PayloadAction<Partial<RegisterState>>) => {
            Object.assign(state, action.payload);
        },
        clearRegisterData: (state) => {
            return initialRegisterState;
        },
        clearFieldError(state, action: PayloadAction<string>) {
            delete state.errors[action.payload];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(registerByUser.pending, (state) => {
                state.status = 'pending';
                state.error = undefined;
                state.isLoading = true;
            })
            .addCase(registerByUser.fulfilled, (state) => {
                state.status = 'fulfilled'; // Устанавливаем статус сразу
                state.isLoading = false;
                state.success = true; // Обновляем success явно
            })
            .addCase(registerByUser.rejected, (state, action) => {
                state.status = 'rejected';
                state.isLoading = false;
                state.error = action.error.message || "Registration error";

                if (action.payload) {
                    state.errors = {...state.errors, ...action.payload};
                }
            });
    },
});


export const {actions: registerActions} = registerSlice;
export const {reducer: registerReducer} = registerSlice;

